<template>
    <div id="who_we_are">
        <div class="imageTop">
            <div class="imageInner">
                <img src="../../assets/images/AboutMTN.png"
                    style="width: auto; height: 100%; position: absolute; z-index: 5" class="about">
                <div v-observe-visibility="visibilityChanged"></div>
                <div class="Lottie">
                    <vue-lottie-player :key="key" name="anime" ref="lottie" width="100%" height="auto"
                        style="position: absolute; right: 0" :animationData="jsonFile" class="LotteAnimation"
                        :class="[lang === 'ar' ? 'arabicAn' : '']" />
                </div>
                <div class="smallContainer">
                    <img src="../../assets/images/AboutMTN2.png" class="rightImageSmall">
                </div>
                <div class="textInside position-absolute">
                    <div>
                        <div class="bigTitle">
                            {{ mainTitle }}
                        </div>
                        <div class="text click-address" :style="lang === 'ar' ? 'font-family: Mtn-arabic-regular' : ''"
                            v-html="description" v-if="display && !error">
                        </div>
                        <Loader v-if="!display && smallSize" style="min-height: 22rem !important;" />
                        <Error v-if="error && smallSize" />
                    </div>
                </div>
            </div>
            <Loader v-if="!display && !smallSize" class="Loadding" />
            <Error v-if="error && !smallSize" class="Loadding" />
        </div>
        <!-- Partners section has been removed -->
    </div>
</template>

<script>
import $ from 'jquery'
import WhoWeAreRepository from '../../repositories/WhoWeAreRepository'
import gc from '../../utils/gc'
import VueLottiePlayer from 'vue-lottie-player'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import json from '../../assets/json/about.json'

export default {
  name: 'WhoWeAre',
  components: { Loader, Error, VueLottiePlayer },
  data () {
    return {
      lang: this.$lang,
      WhoWeAreData: new WhoWeAreRepository(),
      mainTitle: this.$t('whoWeAre.MainTitle'),
      description: '',
      bigImage: '',
      smallImage: '',
      base: gc.baseUrl,
      show: false,
      error: false,
      display: this.show,
      jsonFile: json,
      key: 0,
      smallSize: false
    }
  },
  mounted () {
    this.arabic()
    this.getData()
    this.paddindTitle()
    window.addEventListener('resize', () => {
      this.paddindTitle()
    })
    if (window.innerWidth < 1180) {
      this.smallSize = true
    } else if (window.innerWidth > 1180) {
      this.smallSize = false
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1180) {
        this.smallSize = true
      } else if (window.innerWidth > 1180) {
        this.smallSize = false
      }
    })
  },
  methods: {
    visibilityChanged (isVisible) {
      if (isVisible) {
        this.key++
        this.$forceUpdate()
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('#who_we_are').css('direction', 'rtl')
        $('.textInside').css('text-align', 'right')
        $('.bigTitle, .mainTitle').css('font-family', 'Mtn-arabic-bold')
        $('.textInside').css('background-position', 'left')
        $('.imageInner').css('background-position', 'right')
        $('.textInside').css('padding', '50px 5vw 50px 0vw ')
        $('.LotteAnimation').addClass('arabicAn')
        $('.about').removeClass('whoWeAreImage')
        $('.about').addClass('whoWeAreImageAR')
      } else if (this.$lang === 'en') {
        $('.about').addClass('whoWeAreImage')
        $('.about').removeClass('whoWeAreImageAR')
      }
    },
    paddindTitle () {
      if (window.innerWidth < 800 && this.$lang === 'ar') {
        $('.textInside').css('padding', '0px 5vw 50px 5vw ')
      } else if (window.innerWidth > 800 && this.$lang === 'ar') {
        $('.textInside').css('padding', '50px 5vw 50px 0vw ')
      }
    },
    async getData () {
      try {
        const response = await this.WhoWeAreData.get()
        const desc = response.data.text
        const description = desc.replace(/\\n/g, '')
        if (response.status === 200) {
          this.description = description
          if (this.$lang === 'en') {
            this.description = description.slice(0, 720)
            if (description.length > 721) {
              this.description = description.slice(0, 720) + ' ...'
            }
          } else if (this.$lang === 'ar') {
            this.description = description.slice(0, 620)
            if (description.length > 621) {
              this.description = description.slice(0, 620) + ' ...'
            }
          }
          this.bigImage = response.data.largeImage
          this.smallImage = response.data.image
          this.show = true
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    }
  },
  watch: {
    show (val) {
      this.display = val
      this.$forceUpdate()
    },
    error (val) {
      if (val) {
        this.display = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";

#who_we_are {
    margin-top: 148px;
}

.imageTop {
    background-repeat: no-repeat;
    background-size: 100% 100% !important;
    min-height: 40rem;
    position: relative;
}

.imageInner {
    height: 100%;
    width: 100%;
    margin-top: 45px;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    min-height: 35rem;
}

.textInside {
    height: 100%;
    width: 58%;
    padding: 50px 0 50px 5vw;
    text-align: left;
}

.bigTitle {
    padding: 55px 0;
    font-size: xx-large;
    font-family: Mtn-bold-italic;
    font-style: italic;
}

.about {
    user-select: none;
    pointer-events: none;
}

.text {
    font-family: Mtn-regular;
    overflow-wrap: anywhere;
}

.smallContainer {
    display: none;
}

.Loadding {
    width: 100%;
    position: absolute;
    top: 0;
}

@media only screen and (max-width: 1180px) {
    .imageTop {
        background-image: none;
    }

    .imageInner {
        display: block;
    }

    .smallContainer {
        display: block;
        background-image: $--yellow-gradient;
    }

    .rightImageSmall {
        background-size: 100% 100% !important;
        width: auto;
        height: 100%
    }

    .rightImage,
    .about,
    .Lottie {
        display: none !important;
    }

    .textInside {
        width: 100% !important;
        text-align: center !important;
        background-image: url("../../assets/images/mobileBundles.png");
        background-position: right top;
        min-height: 30rem;
        position: unset !important;
    }

    .Loadding {
        top: 10px;
    }

    .bigTitle {
        color: $--yellow;
        padding: 25px 0;
    }

    .textInside {
        padding: 25px 5vw 25px 5vw;
    }

    .imageInner {
        background-image: none !important;
    }
}

.rightImage {
    background-size: 100% 100% !important;
    width: 70%;
    min-height: 60vh;
}

@media only screen and (max-width: 800px) {
    .rightImageSmall {
        width: 100%;
        height: auto;
    }
}

.whoWeAreImage {
    right: -3%;
}

.whoWeAreImageAR {
    left: -3%;
    transform: rotateY(180deg);
}

.arabicAn {
    transform: rotateY(180deg) !important;
}

@media only screen and (max-width: 1700px) {
    .whoWeAreImage {
        right: -10%;
    }

    .whoWeAreImageAR {
        left: -10%;
    }
}

@media only screen and (max-width: 1370px) {
    .whoWeAreImage {
        right: -15%;
    }

    .whoWeAreImageAR {
        left: -15%;
    }
}

@media only screen and (max-width: 1500px) {
    .textInside {
        width: 56%;
    }
}

@media only screen and (max-width: 1250px) {
    .textInside {
        width: 50%;
    }
}</style>
